import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-210fef1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ps" }
const _hoisted_2 = {
  key: 0,
  class: "ps__elm"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ps__elm-label" }, "Страниц", -1))
const _hoisted_4 = { class: "ps__elm-select-wrap-num" }
const _hoisted_5 = { class: "ps__elm-select-wrap-icon" }
const _hoisted_6 = {
  key: 0,
  class: "ps__elm-select-list"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "ps__elm-total" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconChevron = _resolveComponent("IconChevron")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.totalPages > _ctx.FIRST_PAGE)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", {
            class: "ps__elm-select",
            onFocusout: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFocusOut && _ctx.onFocusOut(...args))),
            tabindex: "0"
          }, [
            _createElementVNode("div", {
              class: "ps__elm-select-wrap",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
            }, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.currentPage), 1),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_IconChevron)
              ])
            ]),
            (_ctx.isShow)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
                    return (_openBlock(), _createElementBlock("div", { key: page }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(
								page === _ctx.currentPage
									? 'ps__elm-select-list-item_current'
									: 'ps__elm-select-list-item'
							),
                        onClick: ($event: any) => (_ctx.onClickSelect(page))
                      }, _toDisplayString(page), 11, _hoisted_7)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 32),
          _createElementVNode("div", _hoisted_8, "из " + _toDisplayString(_ctx.totalPages), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}